import { useState } from "react";
import { Button } from "shared/Components/button";
import { OutlineButton } from "shared/Components/outlineButton";
import Modal from "shared/Components/modal";
import { pending } from "helper/icons";
import { TextInput } from "shared/Components/textInput";

export function EmailChangeConfirmationModal({
  modalRef,
  onConfirm,
  onCancel,
  newEmail
}) {
  const [confirmText, setConfirmText] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (confirmText.toLowerCase() === "confirm") {
      setError("");
      setConfirmText("");
      onConfirm();
    } else {
      setError("Please type 'Confirm' to proceed");
    }
  };

  const handleModalClose = () => {
    // Reset state when modal closes
    setConfirmText("");
    setError("");
  };

  const handleInputChange = (e) => {
    setConfirmText(e.target.value);
    if (error) setError("");
  };

  return (
    <Modal
      extraClass={`pt-0`}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={modalRef}
      onClose={handleModalClose}
      preventClickOnOutside={true}
    >
      <div className="p-8 pb-6 items-center m-auto max-w-[500px]">
        <div className="flex flex-col items-center mb-4">
          <img 
            src={pending} 
            alt="Warning" 
            className="w-12 h-12 mb-4" 
          />
          <span className="text-xl font-semibold text-gray-900 text-center mb-2">
            Confirm Email Change
          </span>
        </div>
        
        <div className="text-sm text-gray-600 text-center mb-4 px-2">
          <p className="mb-3">
            Are you sure you want to change your email address to{" "}
            <span className="font-semibold text-gray-900">{newEmail}</span>?
          </p>
          <p className="mb-3">
            You must have access to the new email address to verify that you are
            the owner of it. A verification email will be sent to the new address.{" "}
            <span className="font-semibold text-gray-900">(You will not be able to log in again until the new email is verified)</span>
          </p>
          <p className="font-medium text-gray-700">
            Type <span className="font-bold">"Confirm"</span> and press the button below to continue.
          </p>
        </div>

        <div className="mb-4">
          <TextInput
            placeholder="Type 'Confirm' here"
            value={confirmText}
            onChange={handleInputChange}
            error={error}
            autoFocus={true}
          />
        </div>

        <div className="flex gap-3 justify-center mt-6">
          <OutlineButton
            onClick={onCancel}
            label="Cancel"
            width="w-[140px]"
          />
          <Button
            onClick={handleConfirm}
            label="Confirm"
            width="w-[140px]"
            disabled={!confirmText}
          />
        </div>
      </div>
    </Modal>
  );
}

